import React, { useState, createContext } from "react"

export const SurveyContext = createContext({
    indexToSkip: 0,
    setIndexToSkip: () => {}
})

export default function SurveyProvider(props) {
    const { children } = props
    const [indexToSkip, setIndexToSkip] = useState(0)

    return (
        <SurveyContext.Provider
            value={{
                indexToSkip,
                setIndexToSkip
            }}
        >
            {children}
        </SurveyContext.Provider>
    )
}
